module.exports = __webpack_public_path__ + "static/media/yellow.dc0cbb2f.png";